import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { HeroSectionComponent } from '../hero-section/hero-section.component';
import { ProductStripSectionComponent } from '../product-strip-section/product-strip-section.component';
import { AdsShowcaseSectionComponent } from '../ads-showcase-section/ads-showcase-section.component';
import { FeaturesSectionComponent } from '../features-section/features-section.component';
import { TestimonialsSectionComponent } from '../testimonials-section/testimonials-section.component';
import { HowItWorksSectionComponent } from '../how-it-works-section/how-it-works-section.component';
import { AppStoreBannerSectionComponent } from '../app-store-banner-section/app-store-banner-section.component';
import { FooterSectionComponent } from '../footer-section/footer-section.component';
import { GuestTopBarComponent } from '../guest-top-bar/guest-top-bar.component';
import { AnimateOnViewDirective } from "../../../directives/animate-on-view/animate-on-view.directive";
import { RouterOutlet } from '@angular/router';
import { FaqSectionComponent } from '../faq-section/faq-section.component';

@Component({
  selector: 'app-guest-main-page',
  templateUrl: './guest-main-page.component.html',
  styleUrl: './guest-main-page.component.scss',
  imports: [
    HeroSectionComponent,
    ProductStripSectionComponent,
    AdsShowcaseSectionComponent,
    FeaturesSectionComponent,
    TestimonialsSectionComponent,
    HowItWorksSectionComponent,
    AppStoreBannerSectionComponent,
    AppStoreBannerSectionComponent,
    FooterSectionComponent,
    GuestTopBarComponent,
    RouterOutlet,
    FaqSectionComponent
  ],
})
export class GuestMainPageComponent implements AfterViewInit {
  ngAfterViewInit(): void {
      this.scrollContainer.nativeElement.addEventListener('scroll', () => {
      const scrollTop = this.scrollContainer.nativeElement.scrollTop;
      this.scrolled = scrollTop > window.innerHeight * 0.05;
    });
  }
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;  
  scrolled = false;

}
